export default {
  FAILED_CAPTCHA: 0,
  EXISTING_UNVERIFIED_SUBSCRIPTION: 1,
  NEW_VERIFICATION_EMAIL_SENT: 2,
  ALREADY_SUBSCRIBED: 3,
};
